'use strict';

const axios = require('axios');

module.exports = (eurobonusData) => {
    return {
        namespaced: true,
        state: {
            ...eurobonusData,
            errorMessage: '',
            showError: false
        },
        getters: {},
        actions: {
            addCode({state, commit}, eurobonusCode) {
                if (!eurobonusCode || eurobonusCode.length != 9) {
                    commit('setErrorMessage', state.resources.minLengthError);
                    commit('setShowError', true);
                    return false;
                }

                const bodyFormData = new FormData();
                bodyFormData.append(state.eurobonusInputName, eurobonusCode);
                bodyFormData.append(state.eurobonusMemberName, true);

                return axios({
                    method: 'post',
                    url: state.eurobonusApplyURL,
                    data: bodyFormData,
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    },
                }).then((result) => {
                    const isSuccess = result.data.success;
                    if (isSuccess) {
                        commit('setCodeValue', eurobonusCode);
                        commit('setCodeValueLabel', result.data.message);
                    }
                    commit('setErrorMessage', result.data.message);
                    commit('setShowError', !isSuccess);
                });
            },
            removeCode({state, commit}) {
                return axios({
                    method: 'post',
                    url: state.eurobonusRemoveURL,
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    },
                }).then(() => {
                    commit('setCodeValue', '');
                    commit('setErrorMessage', '');
                    commit('setShowError', false);
                });
            },
            updateEnabledFlag({state, commit}, isEnabled) {
                const bodyFormData = new FormData();
                const eurobonusMemberValue = isEnabled ? !!state.eurobonusCodeValue : false;
                bodyFormData.append(state.eurobonusMemberName, eurobonusMemberValue);

                return axios({
                    method: 'post',
                    url: state.eurobonusUpdateMemberURL,
                    data: bodyFormData,
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    },
                }).then(() => {
                    commit('setEurobonusEnabled', isEnabled);
                    commit('setErrorMessage', '');
                    commit('setShowError', false);
                });
            }
        },
        mutations: {
            setErrorMessage(state, newMessage) {
                state.errorMessage = newMessage;
            },
            setCodeValue(state, eurobonusCode) {
                state.eurobonusCodeValue = eurobonusCode;
            },
            setCodeValueLabel(state, label) {
                state.resources.eurobonusCodeValueLabel = label;
            },
            setEurobonusEnabled(state, value) {
                state.eurobonusEnabled = value;
            },
            setShowError(state, value) {
                state.showError = value;
            }
        }
    };
};
